/* MODAL DE CREACIÓN DE UBICACIÓN
Datos básicos de una ubicación: nombre, limite maximo, limite por persona, tipo de ubicacion
*/
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControl, InputLabel, Select, MenuItem, Box, Typography} from '@mui/material';

const CreateZonaModal = ({ open, onClose, onConfirm, position }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    limitePorPersona: 1,
    limiteMaximo: 50,
    tipoUbicacion: 1
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.nombre.trim()) {
      newErrors.nombre = 'El nombre es requerido';
    }
    
    if (formData.limitePorPersona < 1) {
      newErrors.limitePorPersona = 'Debe ser mayor a 0';
    }
    
    if (formData.limiteMaximo < 1) {
      newErrors.limiteMaximo = 'Debe ser mayor a 0';
    }
    
    if (formData.limitePorPersona > formData.limiteMaximo) {
      newErrors.limitePorPersona = 'No puede ser mayor al límite máximo';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;
    
    onConfirm(formData);
    setFormData({
      nombre: '',
      limitePorPersona: 1,
      limiteMaximo: 50,
      tipoUbicacion: 1
    });
    setErrors({});
  };

  const handleClose = () => {
    onClose();
    setFormData({
      nombre: '',
      limitePorPersona: 1,
      limiteMaximo: 50,
      tipoUbicacion: 1
    });
    setErrors({});
  };

  const getTipoDescription = (tipo) => {
    switch(tipo) {
      case 1:
        return "Zona general sin asientos específicos. Solo control de aforo.";
      case 2:
        return "Zona con mesas que pueden tener asientos numerados o no numerados.";
      case 3:
        return "Zona con filas de asientos numerados (como un teatro o estadio).";
      default:
        return "";
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Configurar Nueva 
        {position && (
          <Typography variant="caption" color="text.secondary" display="block">
            Posición: ({Math.round(position.x)}, {Math.round(position.y)})
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Nombre de la zona"
            value={formData.nombre}
            onChange={(e) => setFormData({...formData, nombre: e.target.value})}
            fullWidth
            required
            error={!!errors.nombre}
            helperText={errors.nombre}
            placeholder="Ej: Zona VIP, Platea, Palcos..."
          />
          
          <TextField
            label="Límite de compra por persona"
            type="number"
            value={formData.limitePorPersona}
            onChange={(e) => setFormData({...formData, limitePorPersona: parseInt(e.target.value) || 1})}
            fullWidth
            inputProps={{ min: 1 }}
            error={!!errors.limitePorPersona}
            helperText={errors.limitePorPersona || "Cantidad máxima de tickets que puede comprar una persona"}
          />
          
          <TextField
            label="Límite máximo de personas"
            type="number"
            value={formData.limiteMaximo}
            onChange={(e) => setFormData({...formData, limiteMaximo: parseInt(e.target.value) || 1})}
            fullWidth
            inputProps={{ min: 1 }}
            error={!!errors.limiteMaximo}
            helperText={errors.limiteMaximo || "Capacidad total de la zona"}
          />
          
          <FormControl fullWidth>
            <InputLabel>Tipo de ubicación</InputLabel>
            <Select
              value={formData.tipoUbicacion}
              onChange={(e) => setFormData({...formData, tipoUbicacion: e.target.value})}
              label="Tipo de ubicación"
            >
              <MenuItem value={1}>General</MenuItem>
              <MenuItem value={2}>Con mesas</MenuItem>
              <MenuItem value={3}>Con filas de asientos</MenuItem>
            </Select>
          </FormControl>

          <Box sx={{ p: 2, backgroundColor: "#f5f5f5", borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary">
              <strong>Descripción:</strong> {getTipoDescription(formData.tipoUbicacion)}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained"
          disabled={!formData.nombre.trim()}
        >
          Crear Zona
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateZonaModal;